import { TrackingProductModel } from "@omni/types/components/tracking/models/trackingProduct.model";

export const $WishlistModalModuleName = "wishlistModal";

export interface TWishlistModalState {
    visible: boolean;
    product?: TrackingProductModel;
}
